import { render, staticRenderFns } from "./UpdateConsultationFeeModal.vue?vue&type=template&id=37c51158&scoped=true&"
import script from "./UpdateConsultationFeeModal.vue?vue&type=script&lang=js&"
export * from "./UpdateConsultationFeeModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateConsultationFeeModal.vue?vue&type=style&index=0&id=37c51158&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c51158",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
